// extracted by mini-css-extract-plugin
export default {"heading":"\"SF Compact Display\"","body":"\"SF Compact Display\"","mono":"\"JetBrains Mono NL\""};